import { NgModule } from '@angular/core';
import { UIKIT_COMPONENTS } from '@macs-frontend/web/features/ui-kit/components';
import { UIKIT_DIRECTIVES } from '@macs-frontend/web/features/ui-kit/directives';
import { UIModule } from '@macs-frontend/web/features/ui/ui.module';
import { NgrxFormsModule } from 'ngrx-forms';

@NgModule({
  imports: [UIModule, NgrxFormsModule],
  declarations: [...UIKIT_COMPONENTS, ...UIKIT_DIRECTIVES],
  exports: [...UIKIT_COMPONENTS, ...UIKIT_DIRECTIVES],
})
export class UIKitModule {}
